export default (function(context,factory){

	return factory();

})(window,function(){

	/**
	 * @desc 本地存储共用库
	 * @exports wx/storage
	 * @version 1.0.0
	 * @author maixingjie
	 * @copyright Copyright 2017-2027
	 * 
	 */
	var qt_model = {}

	//本地存储
	var sessionStorage = window.sessionStorage;

	//本地会话数据获取
	qt_model.sessionGet = function(key){
		return sessionStorage&&sessionStorage.getItem(key);
	}
	//本地会话数据设置
	qt_model.sessionSet = function(key,value){
		sessionStorage&&sessionStorage.setItem(key,value);
	}
	//本地会话数据删除
	qt_model.sessionDel = function(key){
		sessionStorage&&sessionStorage.removeItem(key);
	}
	//清除 所有本地会话数据
	qt_model.sessionClear = function(){
		sessionStorage && sessionStorage.clear();
	}

	//本地存储
	var localStorage = window.localStorage;

	//本地会话数据获取
	qt_model.localGet = function(key){
		return localStorage&&localStorage.getItem(key);
	}
	//本地会话数据设置
	qt_model.localSet = function(key,value){
		localStorage&&localStorage.setItem(key,value);
	}
	//本地会话数据删除
	qt_model.localDel = function(key){
		localStorage&&localStorage.removeItem(key);
	}
	//清除 所有本地会话数据
	qt_model.localClear = function(){
		localStorage && localStorage.clear();
	}
	return qt_model;

});



// WEBPACK FOOTER //
// ./src/libs/qt/storage.js